import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { usePartners, useUpdatePartner  } from '@/hooks/usePartners'

function WelcomeModal( { isOpen = true, setIsOpen }: { isOpen?: boolean, setIsOpen?: (open: boolean) => void } ) {
  const { data: partnerDetails, isLoading } = usePartners()
  const updatePartner = useUpdatePartner()
  console.log(partnerDetails)

  const handleClose = async () => {
    if(!partnerDetails?.first_login_completed) {
      await updatePartner.mutateAsync({ first_login_completed: true })
    }
    setIsOpen?.(false)
  }

  if(isLoading) return null

  return (
    <Dialog open={!partnerDetails?.first_login_completed || isOpen} onOpenChange={() => {}}>
      <DialogContent 
        className="max-w-[60%] [&>button[class*='absolute']]:hidden" 
        onPointerDownOutside={(e) => e.preventDefault()} 
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="">
            Welcome to the Voice Connector Partner Dashboard
          </DialogTitle>
        </DialogHeader>
          <div className="relative w-full h-[60vh]" style={{ paddingBottom: 0 }}>
            <iframe src="https://www.loom.com/embed/b9488682b8304cb7ae56b52017b782f3?sid=7f628523-92d3-45b5-ae7a-9b1400386e95" frameBorder="0" allowFullScreen className="absolute top-0 left-0 bottom-0 right-0 w-full h-full rounded-lg" />
          </div>
          <Button onClick={handleClose} className='w-fit'>
            Let’s get started
          </Button>
      </DialogContent>
    </Dialog>
  )
}

export default WelcomeModal